import { blogs_api_post_min_data_from_id_url } from 'mk/urls/functions';
import {
    blogsRedirectToTargetApi,
    BlogsRedirectToTargetNormalizedResponse,
    BlogsRedirectToTargetTriggerAction,
    BLOGS_REDIRECT_TO_TARGET_TRIGGER,
} from 'mk2/apps/blogs/containers/BlogsPostSplitter/BlogsPostSplitter.actions';
import { blogsPostDetailUrl } from 'mk2/apps/blogs/urls';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { url } from 'mk2/helpers/urls';
import { getLogger } from 'mk2/logger';
import { BlogPostType } from 'mk2/schemas';
import { redirectInPWASaga } from 'mk2/services/browserHistory';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('blogs/BlogsShortMessageDetail.sagas');

interface ApiResponseGroupPostDetail {
    body: {
        postSlug: string;
        postType: BlogPostType;
    };
}

function* redirectToTarget({ username, postId, xhr }: BlogsRedirectToTargetTriggerAction & XHRAction) {
    yield put(blogsRedirectToTargetApi.request(username, postId));

    try {
        const response: ApiResponseGroupPostDetail = yield call(
            () => xhr.get(blogs_api_post_min_data_from_id_url(), { username, postId }),
        );

        const normalizedResponse: BlogsRedirectToTargetNormalizedResponse = { entities: {}, result: {} };

        const gotoUrl = url(blogsPostDetailUrl(response.body.postType), {
            username,
            postSlug: response.body.postSlug,
        });

        yield put(blogsRedirectToTargetApi.success(username, postId, normalizedResponse));
        yield redirectInPWASaga(gotoUrl, 302);
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(blogsRedirectToTargetApi.failure(username, postId, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(BLOGS_REDIRECT_TO_TARGET_TRIGGER, redirectToTarget),
    ]);
}
